export const ICoordinatorType = Symbol('ITipCoordinator');
